import { create } from "zustand";

/** ADR 403: one place a section can say "I have unsaved edits" so the routed Tabs can hold the door. */
export const useUnsavedStore = create<{ dirty: boolean; nudge: number; setDirty: (d: boolean) => void; bump: () => void }>((set) => ({
  dirty: false, nudge: 0,
  setDirty: (dirty) => set({ dirty }),
  bump: () => set((s) => ({ nudge: s.nudge + 1 })),
}));
